import { useLayoutEffect } from 'react'
import { v4 } from 'uuid'
import { useControlStore } from '@editorStores'

const useSceneLoading = ({ description, enabled }: { description?: string; enabled: boolean }) => {
  const addSceneLoadingIndicator = useControlStore(state => state.addSceneLoadingIndicator)
  const removeSceneLoadingIndicator = useControlStore(state => state.removeSceneLoadingIndicator)

  useLayoutEffect(() => {
    if (!enabled) return

    const id = v4()

    addSceneLoadingIndicator({ id, description })

    return () => removeSceneLoadingIndicator(id)
  }, [addSceneLoadingIndicator, description, enabled, removeSceneLoadingIndicator])
}

export default useSceneLoading
